import { Checkbox } from '@/components/ui/checkbox';
import {
  FormField,
  FormItem,
  FormControl,
  FormDescription,
  FormMessage,
  FormLabel,
} from '@/components/ui/form';
import { PlannerConfigEntityWithOptionalFields } from '@/services/configurator/PlannerConfigTypes';
import { ReactNode } from 'react';
import { Control } from 'react-hook-form';

export type CheckboxFields =
  | 'searchable'
  | 'includeListingSearchParams'
  | 'includeDeeplinkParams';

type FormChecboxComponentProps = {
  formControl: Control<PlannerConfigEntityWithOptionalFields>;
  name: CheckboxFields;
  formLabel: ReactNode;
  formDescription: string;
  disabled: boolean;
};

function FormCheckboxComponent({
  formControl,
  name,
  formLabel,
  formDescription,
  disabled,
}: FormChecboxComponentProps) {
  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field }) => (
        <FormItem>
          <div className='flex flex-row items-start space-x-3 space-y-0'>
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={disabled}
              />
            </FormControl>
            <FormLabel>{formLabel}</FormLabel>
          </div>
          <FormDescription>{formDescription}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default FormCheckboxComponent;
